/**
 * @generated SignedSource<<d5ec2aff7d9709d3d229a3101ee1f9de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseFacetFilterModal_photos$data = {
  readonly totalResults: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilter_photos">;
  readonly " $fragmentType": "PhotosSearchBrowseFacetFilterModal_photos";
};
export type PhotosSearchBrowseFacetFilterModal_photos$key = {
  readonly " $data"?: PhotosSearchBrowseFacetFilterModal_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilterModal_photos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseFacetFilterModal_photos",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFacetFilter_photos"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a60053c1e95b7cf51d8e9960a2ac1ef8";

export default node;
